<script>
     import { res, state } from './stores'

     let all_sc = $res.cards.filter(c =>  c && c.id && c.area == 'SOLO CHALLENGE');

     let sc_names = Array.from(new Set(all_sc.map(c => c.name).filter(n => n != `One man's terrorist...`)));

     let sc_cards = [];
     for(let n of sc_names){
        sc_cards.push(all_sc.find(c => c.name == n));
     }

</script>

<div>
    <div style="font-weight: bold;">Conspiring Admiral Challenges</div>
    <div>
        Boost the bot's difficulty by adding any combination of the following cards:
        <ul style='list-style-type: none;'>
            {#each sc_cards as c}
                <li><input type="checkbox" bind:checked={$state.soloChallenge[c.name]} />&nbsp;{c.name} (from {c.box})</li>
            {/each}
            {#if $res.modules.includes('Badlands')}
                <li><input type="checkbox" bind:checked={$state.soloChallenge[`One man's terrorist...`]} />&nbsp;One man's terrorist... (for use with <i>Badlands</i> only)</li>
            {/if}
        </ul>
    </div>
</div>

